import React from "react";
import { Stepper as TwStepper, Step, Typography } from "@material-tailwind/react";
import {
	TruckIcon,
	UserIcon,
	CurrencyDollarIcon,
	CheckIcon
} from "@heroicons/react/24/outline";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { orderController } from "../Controllers/OrderController";

export const Stepper = observer(() => {
	const navigate = useNavigate()

	return (
    <div className="w-full bg-gray-800 py-2 xlh:pb-10 flex items-center px-2 xs:px-4 md:px-24 border-b-2 border-gray-200">
			<TwStepper
				activeStep={orderController.activeStep}
      >
        <Step className="h-8 w-8 mdh:h-10 mdh:w-10 cursor-pointer">
          <UserIcon className="h-5 w-5" onClick={() => {
						if (orderController.activeStep !== 0) {
							orderController.activeStep = 0;
							navigate("/checkout/step-1")
						}
					}} />
          <div className="hidden xlh:block absolute -bottom-[2rem] w-max text-center">
						<Typography
							variant="h6"
							color="white">
							Review your order
						</Typography>
					</div>
				</Step>
        <Step className="h-8 w-8 mdh:h-10 mdh:w-10 cursor-pointer">
					<TruckIcon className="h-5 w-5" onClick={() => {
						if (orderController.activeStep !== 1) {
							orderController.activeStep = 1;
							navigate("/checkout/step-2")
						}
					}} />
          <div className="hidden xlh:block absolute -bottom-[2rem] w-max text-center">
						<Typography
							variant="h6"
							color="white">
							Provide delivery details
						</Typography>
					</div>
				</Step>
        <Step className="h-8 w-8 mdh:h-10 mdh:w-10">
					<CurrencyDollarIcon className="h-5 w-5" onClick={() => {
						
					}} />
          <div className="hidden xlh:block absolute -bottom-[2rem] w-max text-center">
						<Typography
							variant="h6"
							color="white">
							Pay
						</Typography>
					</div>
				</Step>
        <Step className="h-8 w-8 mdh:h-10 mdh:w-10">
					<CheckIcon className="h-5 w-5" />
          <div className="hidden xlh:block absolute -bottom-[2rem] w-max text-center">
						<Typography
							variant="h6"
							color="white"
						>
							Order Confirmation
						</Typography>
					</div>
				</Step>
			</TwStepper>
		</div>
	);
})